{
  "version": 1,
  "asset_id": "aeaf508b-6d13-4c50-a968-6b7e10b83f34",
  "project_id": "7580f3ab-e7a4-418d-abe6-5eb616986e51",
  "url": "/__l5e/assets-v1/aeaf508b-6d13-4c50-a968-6b7e10b83f34/destination-roofing-tan-standing-seam-metal-roof-pine-ridge-fl-1320w.webp",
  "r2_key": "a/v1/7580f3ab-e7a4-418d-abe6-5eb616986e51/aeaf508b-6d13-4c50-a968-6b7e10b83f34/destination-roofing-tan-standing-seam-metal-roof-pine-ridge-fl-1320w.webp",
  "original_filename": "destination-roofing-tan-standing-seam-metal-roof-pine-ridge-fl-1320w.webp",
  "size": 111274,
  "content_type": "image/webp",
  "created_at": "2026-07-16T20:37:56Z"
}
